"use client";

import React, { createContext, useContext } from "react";
import { getFeatureFlags } from "@/lib/feature-flags";

type FeatureFlags = ReturnType<typeof getFeatureFlags>;

type FeatureFlagKeys = keyof FeatureFlags;

interface GlobalFeatureFlagsContextType {
  flags: FeatureFlags;
  isFeatureEnabled: (feature: FeatureFlagKeys) => boolean;
}

const GlobalFeatureFlagsContext = createContext<GlobalFeatureFlagsContextType | undefined>(
  undefined
);

export const useGlobalFeatureFlags = () => {
  const context = useContext(GlobalFeatureFlagsContext);
  if (!context) {
    throw new Error("useGlobalFeatureFlags must be used within a GlobalFeatureFlagsProvider");
  }
  return context;
};

interface GlobalFeatureFlagsProviderProps {
  children: React.ReactNode;
}

export const GlobalFeatureFlagsProvider: React.FC<GlobalFeatureFlagsProviderProps> = ({
  children,
}) => {
  const flags = getFeatureFlags();

  const isFeatureEnabled = (feature: FeatureFlagKeys): boolean => {
    return flags[feature] || false;
  };

  return (
    <GlobalFeatureFlagsContext.Provider value={{ flags, isFeatureEnabled }}>
      {children}
    </GlobalFeatureFlagsContext.Provider>
  );
};
